<div *ngIf="!showLoader" class="container no-padding full-width border-head cboth main-fix-footer-pad">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding flex-center-div mob-pad-10">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 left-sec no-padding dont-display">
        </div>
        <div
            class="col-xs-12 col-sm-12 col-md-6 col-lg-6 right-sec no-padding card-box-shadow top-bottom-spec-50 mob-top-bottom-spc-40">
            <div class="col-xs-12 text-center">
                <span class="lighter-text">Welcome Back </span>
                <span class="bold-text" *ngIf="UserName">{{UserName}}!</span>
            </div>
            <div class="clearfix">
                <div class="tabContainer">
                    <div class="mobTab">
                        <label class="enabled tab-view-spec">
                            <i class="icon-Bajaj_Icon_ULIP_your_application"></i>
                            <span class="active-underscore active-underscore-tellus"></span>Your
                            <span class="tab-title">Application (s)</span>
                        </label>
                    </div>
                    <div class="clearfix">
                        <div class="col-xs-12 col-md-12">
                            <div class="clearfix" [formGroup]="SelectApplication">
                                <div class="col-xs-12 text-center h3 bottom-spc-20">
                                    <h4 class="sec-head-spec">Select one you wish to resume</h4>
                                </div>
                                <!-- Application List -->
                                <div class="clearfix" *ngIf="ApplicationList && ApplicationList.length > 0">
                                    <!-- product-row active-->
                                    <app-selection-list [selectionListOptions]="AppSelectionOptions"
                                        (selection)="OnAppSelection($event)" class="apps">
                                        <div class="selection-list-content row" id="row-{{itemIndex}}"
                                            *ngFor="let productItem of AppSelectionOptions.DataProvider;let itemIndex = index"
                                            [ngClass]="(ApplicationList.length>1)?'col-md-6 col-sm-12 col-xs-12 product-row':'col-md-12 col-sm-12 col-xs-12 product-row active' ">
                                            <input class="proCheckBox" type="radio" [value]="productItem.processId"
                                                formControlName="productName" name="productName"
                                                [id]="'loan-'+itemIndex">
                                            <div class="loanType margin-value">
                                                <div class="active"></div>
                                                <div class="row">
                                                    <div class="mark">
                                                        <span class="input-group-addon left">
                                                            <i>&#10003;</i>
                                                        </span>
                                                    </div>
                                                    <div class="progressbar clearfix pull-right col-xs-5 nopadding">
                                                        <div class="outer-circle">
                                                            <app-circle-progress-bar
                                                                [progessValue]="productItem.appCompletionPercentage">
                                                            </app-circle-progress-bar>
                                                        </div>
                                                    </div>
                                                    <div class="loan-info col-xs-7 nopadding">
                                                        <h1>{{productItem.loanProduct}}</h1>
                                                        <h4>Application ID - {{productItem.applicationKey}}</h4>
                                                        <p>{{productItem.lastAccessedTime}} days ago</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </app-selection-list>
                                    <div class="bre-error-message" *ngIf="errorMessage">
                                        {{errorMessage}}
                                    </div>
                                    <!-- Form Buttons -->
                                    <div class="row btnGroupFixed navigationButtonsBox">
                                        <div class="">
                                            <button type="submit" id="existingCust_next" [disabled]="isReadonly"
                                                class="btn btn-block btnconfirm btn-css"
                                                (click)="OnSubmit(SelectApplication.value)">RESUME</button>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="ApplicationList?.length == 0" class="col-xs-12 text-center h3">
                                    <h3>Oops! We couldnt find this number in our records</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<section *ngIf="showLoader">
    <app-loader></app-loader>
</section>